import React, { memo, useMemo } from 'react'
import { Modal } from '@mui/material'
import tw from 'twin.macro'
import { AddEditDeclineReasonForm } from './add-edit-decline-reason-form/AddEditDeclineReasonForm'
import { RejectionReason } from 'src/interfaces/rejectionReason'

interface Props {
  isOpen: boolean
  initialReason?: RejectionReason | null
  isLoading?: boolean
  onClose: () => void
  onSave: () => void
}

const AddEditDeclineReasonModalComponent = ({ isOpen, initialReason, onClose, onSave }: Props) => {
  const container = useMemo(() => document.getElementById('root'), [])

  return (
    <Modal
      container={container}
      open={isOpen}
      aria-labelledby="add-reason-modal-title"
      aria-describedby="add-reason-modal-description"
      css={tw`flex justify-center items-center backdrop-blur p-4 z-[2001]`}
      onClose={onClose}
    >
      <AddEditDeclineReasonForm initialReason={initialReason} onClose={onClose} onSubmit={onSave} />
    </Modal>
  )
}

export const AddEditDeclineReasonModal = memo(AddEditDeclineReasonModalComponent)
